import { each } from 'lodash';
import Vue from 'vue';
import { Button, Message, Loading, Form, FormItem, Input, Select, Option, Col, Row, Checkbox, Dialog, Alert, Result, MessageBox } from 'element-ui';
export function registerElementComponents() {
    each([
        Button, Loading.directive, Form, FormItem, Input, Select, Option, Col, Row, Checkbox, Dialog, Alert, Result
    ], component => {
        Vue.use(component);
    });
    Vue.prototype.$message = Message;
    Vue.prototype.$msgbox = MessageBox;
}
